import React from "react";
import { Link } from "react-router-dom";
import { Send, MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer id="footer_main" className="bg-neutral-900/50 border-t border-neutral-800/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div className="col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-md bg-primary-600 flex items-center justify-center">
                <span className="text-white font-medium text-lg">О</span>
              </div>
              <span className="text-lg font-extralight text-neutral-200">
                Обстучим
              </span>
            </Link>
            <p className="text-lg font-extralight text-neutral-500 mb-4">
              AI-напарник и эксперты из реального бизнеса для решения ваших задач
            </p>
            <div className="flex items-center gap-3">
              <a
                href="#"
                className="p-2 rounded-md bg-neutral-800/50 text-neutral-500 hover:text-neutral-200 hover:bg-neutral-800 transition-colors"
              >
                <Send className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="p-2 rounded-md bg-neutral-800/50 text-neutral-500 hover:text-neutral-200 hover:bg-neutral-800 transition-colors"
              >
                <MessageCircle className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-medium text-neutral-300 mb-4">Платформа</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/experts" className="text-lg font-extralight text-neutral-500 hover:text-neutral-200 transition-colors">
                  Найти людей
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-lg font-extralight text-neutral-500 hover:text-neutral-200 transition-colors">
                  Как это работает
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-lg font-extralight text-neutral-500 hover:text-neutral-200 transition-colors">
                  Тарифы
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-medium text-neutral-300 mb-4">Компания</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-lg font-extralight text-neutral-500 hover:text-neutral-200 transition-colors">
                  О нас
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-lg font-extralight text-neutral-500 hover:text-neutral-200 transition-colors">
                  Контакты
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-medium text-neutral-300 mb-4">Документы</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" className="text-lg font-extralight text-neutral-500 hover:text-neutral-200 transition-colors">
                  Конфиденциальность
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-lg font-extralight text-neutral-500 hover:text-neutral-200 transition-colors">
                  Условия
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-neutral-800/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <p className="text-lg font-extralight text-neutral-600 text-center">
            © {new Date().getFullYear()} Обстучим. Все права защищены.
          </p>
        </div>
      </div>
    </footer>
  );
}